class BmProductGallery extends HTMLElement {
  connectedCallback() {
    this.mainGallery = this.querySelector('[data-product-gallery]');
    this.thumbnails = this.querySelectorAll('[data-thumbnail]');

    this.thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => this.setActiveMedia(thumbnail.dataset.mediaId));
    });

    const firstImage = this.mainGallery?.querySelector('[data-media-id]');
    if (firstImage) this.setActiveThumbnail(firstImage.dataset.mediaId);

    this.observeActiveImage();
  }

  setActiveMedia(mediaId) {
    if (!this.mainGallery || !mediaId) return;

    const target = this.mainGallery.querySelector(`[data-media-id="${mediaId}"]`);
    if (target) this.mainGallery.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });

    this.setActiveThumbnail(mediaId);
  }

  setActiveThumbnail(mediaId) {
    this.thumbnails.forEach((thumbnail) => {
      const isActive = thumbnail.dataset.mediaId === mediaId;
      thumbnail.classList.toggle('opacity-100', isActive);
      thumbnail.classList.toggle('opacity-20', !isActive);
    });
  }

  observeActiveImage() {
    if (!this.mainGallery || !('IntersectionObserver' in window)) return;

    const images = this.mainGallery.querySelectorAll('[data-media-id]');
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.find((entry) => entry.isIntersecting);
        if (visible) this.setActiveThumbnail(visible.target.dataset.mediaId);
      },
      { root: this.mainGallery, threshold: 0.6 }
    );

    images.forEach((image) => observer.observe(image));
  }
}

customElements.define('bm-product-gallery', BmProductGallery);
